import React from 'react';
import styled from 'styled-components';
import IconContainer from './IconContainer';

export default function SearchOverlay(props) {
  const { icons, setIsSearching, searchTerm } = props;
  const isActive = icons.length > 0 || searchTerm != '';
  function whenClicked() {
    if (!isActive) {
      setIsSearching(false);
    }
  }
  return (
    <Container active={isActive} onClick={whenClicked}>
      <div className="content">
        {isActive ? (
          <div className="width-container">
            <h2>RESULTS</h2>
            <IconContainer icons={icons} />
          </div>
        ) : null}
      </div>
    </Container>
  );
}

const Container = styled.div`
  background-color: #ffffff;
  margin-bottom: 40px;
  /* margin-top: 65px; */
  height: 100%;
  min-height: 100vh;
  width:100%;
  z-index: 10;
  .content {
    h2 {
      line-height: 1.42;
      letter-spacing: 0.86px;
      color: #eb2227;
      margin-bottom: 45px;
    }
    
  }
  ${({ active }) =>
    !active
      ? `
     position: fixed;
     top: 0;
     opacity: 0.8;
    
  `
      : `
  
  `}
  

  
  
  
  
  /* width: ${({ active }) => (active ? '100%' : '100vw')}; */
  

  
`;
